import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=04ec1430&scoped=true&"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=04ec1430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ec1430",
  null
  
)

export default component.exports